import script from "./ResourceQuotaEntry.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourceQuotaEntry.vue?vue&type=script&setup=true&lang=ts"

import "./ResourceQuotaEntry.vue?vue&type=style&index=0&id=677656cc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-677656cc"]])

export default __exports__